import { getElementOrParentByClassName } from '../helpers/utils';
import '../../styles/components/_dialog.scss';
import Scroll from '../modules/Scroll';
import { isOverlayShown } from '../modules/Overlay';
class DialogWrapper extends HTMLElement {
    constructor() {
        super();
        this.onclose = this.onClose.bind(this);
        this.closeButtonClick = this.onCloseButtonClick.bind(this);
    }
    dialog;
    onclose;
    closeButtonClick;
    connectedCallback() {
        console.debug("dialog-wrapper connected");
        const template = document.getElementById('utk-main-dialog-template');
        if (!template) {
            console.error(`dialog template (${template}) not defined; unable to generate dialog`);
        }
        else {
            this.dialog = template.content.firstElementChild.cloneNode(true);
            this.append(this.dialog);
            this.dialog.addEventListener("close", this.onclose);
            this.dialog.addEventListener("click", this.closeButtonClick);
        }
    }
    disconnectedCallback() {
        console.debug("dialog-wrapper disconnected");
        if (this.dialog) {
            this.dialog.removeEventListener("close", this.onclose);
            this.dialog.removeEventListener("click", this.closeButtonClick);
        }
    }
    onClose() {
        this.remove();
    }
    onCloseButtonClick(e) {
        const target = e.target;
        if (getElementOrParentByClassName(target, 'main-dialog__close-button')) {
            e.stopPropagation(); // prevents an inner dialog from closing an outer dialog
            this.close();
        }
    }
    setContent(...content) {
        this.dialog.querySelector('.main-dialog__content').append(...content);
    }
    showDialog() {
        this.dialog.show();
    }
    showModal() {
        Scroll.lock();
        this.dialog.showModal();
    }
    close() {
        this.dialog.close();
        // ensure no other dialogs or overlays are showing before unlocking scroll
        // TODO: better encapsulate the logic elsewhere
        if (!document.querySelector("dialog[open]") && !isOverlayShown()) {
            Scroll.unlock();
        }
    }
    getDialogEl() {
        return this.dialog;
    }
    isOpen() {
        return this.dialog?.open;
    }
}
if (!window.customElements.get("dialog-wrapper")) {
    customElements.define("dialog-wrapper", DialogWrapper);
}
